import { createRoot } from "react-dom/client";
import App from "~@/App";
import "~@/assets/styles/index.scss";
import reportWebVitals from "./reportWebVitals";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { BrowserRouter } from "react-router-dom";
import { sendWebVitalsToAnalytics } from "~@/analytics/webVitals";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Default is true — every window blur/focus cycle (e.g. clicking into
      // DevTools) cancels in-flight requests and refires them, which reads
      // as "the request keeps aborting and never completes".
      refetchOnWindowFocus: false,
    },
  },
});

const root = createRoot(document.getElementById("root") as HTMLElement);
root.render(
  <BrowserRouter basename="/">
    <QueryClientProvider client={queryClient}>
      <App />
      <ReactQueryDevtools initialIsOpen={false} />
    </QueryClientProvider>
  </BrowserRouter>
);

reportWebVitals(sendWebVitalsToAnalytics);
